import { CONST_AUTH } from 'features/Auth/reducers';
import { CONST_COMMON } from 'features/Common/reducers';

export const CONST = {
  APP_INIT: 'APP_INIT',
  SIGNIN_CLICK: 'SIGNIN_CLICK',
  ...CONST_AUTH,
  ...CONST_COMMON,
};
